import { c as _c } from "react/compiler-runtime";
import { toRecord } from '@newfront-insurance/core';
import type { InsurableItemType, InsurableItemTypeDefinition } from '@newfront-insurance/coverage-api';
import type { NextApiError } from '@newfront-insurance/next-api-error';
import type { NextApiSubscription, ConfigInterface } from '@newfront-insurance/next-api-swr';
import { useNextApiSubscription } from '@newfront-insurance/next-api-swr';
import { useContext, useMemo, useCallback } from 'react';
import { routes } from '../bff/routes';
import type { GetInsurableItemTypeDefinitionsResponse } from '../bff/types';
import { CoverageApiContext } from '../provider';
function useInsurableItemTypeDefinitions(config) {
  const $ = _c(2);
  const {
    basePath
  } = useContext(CoverageApiContext);
  let t0;
  if ($[0] !== basePath) {
    t0 = routes.insurableItemTypeDefinitions.getUrl({}, basePath);
    $[0] = basePath;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useNextApiSubscription(t0, config);
}
export interface InsurableItemTypeDefinitionsHelpers {
  loading: boolean;
  error?: NextApiError;
  insurableItemTypes: InsurableItemType[];
  insurableItemTypeDefinitions: Record<InsurableItemType, InsurableItemTypeDefinition>;
  renderInsurableItemType: (insurableItemType: InsurableItemType) => string;
}
export function useInsurableItemTypeDefinitionsHelpers(config) {
  const $ = _c(16);
  const {
    data,
    error
  } = useInsurableItemTypeDefinitions(config);
  let t0;
  let t1;
  if ($[0] !== data?.insurableItemTypes) {
    t1 = data?.insurableItemTypes ?? [];
    $[0] = data?.insurableItemTypes;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  t0 = t1;
  const insurableItemTypeDefinitionsArray = t0;
  let t2;
  let t3;
  if ($[2] !== insurableItemTypeDefinitionsArray) {
    t3 = insurableItemTypeDefinitionsArray || [];
    $[2] = insurableItemTypeDefinitionsArray;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = toRecord(t3, _temp);
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  t2 = t4;
  const insurableItemTypeDefinitions = t2;
  let t5;
  let t6;
  if ($[6] !== insurableItemTypeDefinitionsArray) {
    t6 = insurableItemTypeDefinitionsArray.map(_temp2);
    $[6] = insurableItemTypeDefinitionsArray;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  t5 = t6;
  const insurableItemTypes = t5;
  let t7;
  if ($[8] !== insurableItemTypeDefinitions) {
    t7 = type => insurableItemTypeDefinitions[type]?.readableName || type;
    $[8] = insurableItemTypeDefinitions;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const renderInsurableItemType = t7;
  const t8 = !data && !error;
  let t9;
  if ($[10] !== error || $[11] !== insurableItemTypeDefinitions || $[12] !== insurableItemTypes || $[13] !== renderInsurableItemType || $[14] !== t8) {
    t9 = {
      loading: t8,
      error,
      insurableItemTypes,
      insurableItemTypeDefinitions,
      renderInsurableItemType
    };
    $[10] = error;
    $[11] = insurableItemTypeDefinitions;
    $[12] = insurableItemTypes;
    $[13] = renderInsurableItemType;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
}
function _temp2(t0) {
  const {
    id: id_0
  } = t0;
  return id_0;
}
function _temp(t0) {
  const {
    id
  } = t0;
  return id;
}